export default __webpack_public_path__ + "static/media/grids.d1e07d54.md";